import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import { VIEW_DETAILS_COMMON_KEYS, VIEW_STOP_CHEQUE_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function StopChequeDetails({ option = {} }) {
  const {t}=useTranslation()
  return (
    <Row xs={12}>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.ACCOUNT_NO)}</label>
        <span>{option?.accNo || '-'}</span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.CURRENT_LEVEL)}</label>
        <span>{option?.currentLevel || '-'}</span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.BRANCH)}</label>
        <span>{option?.branchCode || '-'}</span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.EFFECTIVE_DATE)}</label>
        <span>
          {option?.effectiveDate !== null
            ? option?.effectiveDate
            : '-'}
        </span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.START_CHEQUE_NO)}</label>
        <span>{option?.startChequeNo || '-'}</span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.END_CHEQUE_NO)}</label>
        <span>{option?.endChequeNo || '-'}</span> 
      </Col>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
      <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>
          {option?.initDate !== null
            ? option?.initDate
            : '-'}
        </span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.REASON)}</label>
        <span>{option?.reason || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>
          {option?.authDate !== null
            ? option?.authDate
            : '-'}
        </span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_STOP_CHEQUE_DETAILS_KEYS.AUTHORIZER_COMMENT)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
